import { SVGProps } from 'react';
const RocketIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={180}
    height={181}
    viewBox="0 0 180 181"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_dd_1742_1492)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M146.598 33.4073C151.788 50.4069 148.01 84.3942 129.481 102.923C132.078 113.074 125.941 120.865 120.157 126.649L104.852 141.954C102.257 144.55 97.8424 143.557 96.6078 140.1L91.0019 124.405C90.6167 124.539 90.2478 124.715 89.8667 124.896C88.4573 125.566 86.8799 126.316 83.6838 125.349C69.6301 158.141 33.9627 146.776 33.4075 146.597L33.4052 146.6C33.4052 146.6 33.4048 146.598 33.404 146.596C33.402 146.596 33.401 146.595 33.401 146.595L33.4031 146.593C33.2239 146.038 21.859 110.37 54.6509 96.3168C53.6846 93.1207 54.4345 91.5433 55.1046 90.1339C55.2858 89.7528 55.4612 89.3839 55.5952 88.9987L39.8999 83.3928C36.4433 82.1582 35.4508 77.7441 38.0462 75.1486L53.3515 59.8433C59.1355 54.06 66.9259 47.9224 77.0773 50.5196C95.6062 31.9907 129.593 28.2122 146.593 33.4031L146.595 33.4007C146.596 33.4018 146.596 33.403 146.597 33.4042C146.598 33.4045 146.599 33.4048 146.6 33.4051L146.598 33.4073Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_dd_1742_1492)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.5796 108.215C98.8712 108.215 99.1643 108.272 99.4379 108.387C100.039 108.635 100.502 109.132 100.707 109.748L104.394 120.811L110.29 114.915C113.573 111.632 115.145 106.92 114.49 102.314L114.086 99.4938C113.988 98.7955 114.222 98.0913 114.722 97.5919C133.199 79.1127 133.759 53.6196 133.521 46.51C126.402 46.2872 100.878 46.8688 82.4375 65.3076C81.9381 65.807 81.2309 66.0402 80.5356 65.9431L77.7142 65.5394C73.1045 64.8859 68.3961 66.4529 65.1112 69.7394L59.2171 75.6349L70.2801 79.3221C70.8961 79.5269 71.3925 79.9904 71.6407 80.59C71.8904 81.1911 71.868 81.8699 71.5764 82.4515C70.3877 84.8393 67.6066 91.8144 68.4021 96.4496L83.5783 111.626C88.2179 112.43 95.187 109.643 97.5779 108.451C97.8919 108.295 98.2358 108.215 98.5796 108.215ZM103.414 127.206C103.242 127.206 103.07 127.186 102.899 127.146C102.143 126.968 101.533 126.41 101.287 125.673L97.2325 113.51C93.7457 114.932 87.0876 117.151 81.9172 115.857C81.5239 115.76 81.1651 115.555 80.8765 115.268L64.7613 99.1514C64.4727 98.8628 64.2694 98.5039 64.1707 98.1092C62.8803 92.9478 65.0962 86.2822 66.5196 82.7969L54.3562 78.7419C53.6191 78.4967 53.0614 77.8867 52.8834 77.1301C52.704 76.3735 52.9298 75.5781 53.48 75.0294L61.9399 66.568C66.2146 62.2903 72.3419 60.2464 78.3466 61.0971L80.0706 61.3438C103.056 39.1536 134.529 42.0169 135.87 42.15C136.931 42.2561 137.773 43.0964 137.878 44.158C138.012 45.5022 140.874 76.9716 118.684 99.9588L118.931 101.681C119.783 107.678 117.738 113.81 113.461 118.088L105 126.549C104.575 126.975 104.003 127.206 103.414 127.206ZM46.8304 133.181L46.8349 133.181C47.0532 133.184 47.27 133.187 47.4853 133.187C63.9026 133.187 70.1166 123.682 71.8256 120.249L59.7564 108.178C56.2487 109.887 46.5598 116.155 46.8304 133.181ZM47.4913 137.673C46.5359 137.673 45.552 137.643 44.5353 137.581C43.402 137.514 42.4989 136.611 42.4316 135.478C41.6376 122.214 46.2623 114.225 50.2814 109.857C54.7041 105.052 59.3707 103.462 59.568 103.397C60.368 103.132 61.2591 103.34 61.8602 103.939L76.0735 118.153C76.6731 118.754 76.8839 119.64 76.6163 120.445C76.5564 120.626 70.6115 137.673 47.4913 137.673ZM99.1578 72.6314C99.1578 68.5091 102.512 65.1554 106.634 65.1554C110.756 65.1554 114.11 68.5091 114.11 72.6314C114.11 76.7536 110.756 80.1074 106.634 80.1074C102.512 80.1074 99.1578 76.7536 99.1578 72.6314ZM94.6723 72.6314C94.6723 79.2267 100.039 84.5929 106.634 84.5929C113.229 84.5929 118.595 79.2267 118.595 72.6314C118.595 66.0361 113.229 60.6698 106.634 60.6698C100.039 60.6698 94.6723 66.0361 94.6723 72.6314Z"
        fill="url(#paint0_linear_1742_1492)"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_1742_1492"
        x={7.35596}
        y={15.2734}
        width={165.371}
        height={165.371}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={12} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1742_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1742_1492"
          result="effect2_dropShadow_1742_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1742_1492"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_1742_1492"
        x={30.3413}
        y={33.9615}
        width={119.726}
        height={119.711}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={6} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1742_1492"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1742_1492"
          result="effect2_dropShadow_1742_1492"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1742_1492"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1742_1492"
        x1={41.4439}
        y1={140.977}
        x2={138.067}
        y2={140.977}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#990099" />
        <stop offset={1} stopColor="#FF0000" />
      </linearGradient>
    </defs>
  </svg>
);
export default RocketIcon;
